import {
    EnumUtility,
    LoggerUtility
} from '../components/ComponentsLibrary';


let configLibrary = null;

// Load config once at module initialization
const loadConfig = async () => {
    if (configLibrary !== null) return configLibrary;
    
    try {
        const response = await fetch('/config.json');
        if (response.ok) {
            configLibrary = await response.json();
            console.log("Config loaded successfully for API operations");
        } else {
            console.warn("Could not load config.json, using environment-based detection");
            configLibrary = {}; // Empty object to prevent repeated fetch attempts
        }
    } catch (error) {
        console.warn("Config loading failed:", error.message);
        configLibrary = {}; // Empty object to prevent repeated fetch attempts
    }
    
    return configLibrary;
};

// Load config immediately when module loads
await loadConfig();

const ApiConfig = (() => {



    return {
        
    };
})();


const ApiPrimaryUrls = {

    //Front end URL:
    devFrontEndUrl: 'ytrac_app_g4_dev.youngwilliams.com',
    qaFrontEndUrl: 'ytrac_app_g4_qa.youngwilliams.com',
    uatFrontEndUrl: 'ytrac_app_g4_uat.youngwilliams.com',
    stgFrontEndUrl: 'ytrac_app_g4_stg.youngwilliams.com',
    prodFrontEndUrl: 'y-trac.youngwilliams.com',

    devWfFrontEndUrl: 'ytrac_app_wf_dev.youngwilliams.com',
    qaWfFrontEndUrl: 'ytrac_app_wf_qa.youngwilliams.com',
    uatWfFrontEndUrl: 'ytrac_app_wf_uat.youngwilliams.com',

    //Client API URLs:
    localClientApiUrl: 'localhost',
    devClientApiUrl: 'ytrac_apiclient_g4_dev.youngwilliams.com',
    qaClientApiUrl: 'ytrac_apiclient_g4_qa.youngwilliams.com',
    uatClientApiUrl: 'ytrac_apiclient_g4_uat.youngwilliams.com',
    stgClientApiUrl: 'ytrac_apiclient_g4_stg.youngwilliams.com',
    ProdClientApiUrl: 'y-trac-apiclient.youngwilliams.com',

    //SSO API URLs:
    localSSOApiUrl: 'localhost',
    devSSOApiUrl: 'ytrac_apisso_g4_dev.youngwilliams.com',
    qaSSOApiUrl: 'ytrac_apisso_g4_qa.youngwilliams.com',
    uatSSOApiUrl: 'ytrac_apiSSO_g4_uat.youngwilliams.com',
    stgSSOApiUrl: 'ytrac_apiSSO_g4_stg.youngwilliams.com',
    ProdSSOApiUrl: 'y-trac-apisso.youngwilliams.com',

    //Master API URLs:
    localMasterApiUrl: 'localhost',
    devMasterApiUrl: 'ytrac_apimaster_g4_dev.youngwilliams.com',
    qaMasterApiUrl: 'ytrac_apimaster_g4_qa.youngwilliams.com',
    uatMasterApiUrl: 'ytrac_apimaster_g4_uat.youngwilliams.com',
    stgMasterApiUrl: 'ytrac_apimaster_g4_stg.youngwilliams.com',
    ProdMasterApiUrl: 'y-trac-apimaster.youngwilliams.com',

    //Document API URLs:
    localDocApiUrl: 'localhost',
    devDocApiUrl: 'ytrac_apidoc_g4_dev.youngwilliams.com',
    qaDocApiUrl: 'ytrac_apidoc_g4_qa.youngwilliams.com',
    uatDocApiUrl: 'ytrac_apidoc_g4_uat.youngwilliams.com',
    stgDocApiUrl: 'ytrac_apidoc_g4_stg.youngwilliams.com',
    ProdDocApiUrl: 'y-trac-apidoc.youngwilliams.com',

};

const ApiGuidKeys = {

    //Client API KEYS:
    localClientApiKeys: ['772dbe2b-7f6d-49b1-ac92-2d89db98b340','154a595b-9b07-413b-907f-e26f1237c0e1','289a730e-987e-4854-8af2-742730296232'],
    devClientApiKeys: ['772dbe2b-7f6d-49b1-ac92-2d89db98b340','154a595b-9b07-413b-907f-e26f1237c0e1','289a730e-987e-4854-8af2-742730296232'],
    qaClientApiKeys: ['04dbfaec-fbfe-4a50-8a81-c0bc3e7e3725','bf224945-c7e3-4a9d-aced-f55a504f2953','0db5c9fd-0acf-4d2a-8871-9e94be03923f'],
    uatClientApiKeys: ['d1a20257-6630-4f13-8eb5-145dc30b642e','b1ae7e34-062d-4ced-92e7-5e6f7f8dd03f','4be71230-0666-475e-9959-75012359b0de'],
    stgClientApiKeys: ['136f8e5e-ff14-4846-b292-89b5d75778fe','eec06cc5-1bae-4311-ab5d-39cf92e7cca0','d16c75af-d4c2-423b-8f62-2454dfc0ea26'],
    ProdClientApiKeys: ['1b2a31a1-17e7-4496-acb4-aaa342bfefeb','3ede538a-7502-4715-8f2d-e75fd4aabf92','53e30464-7aae-471c-88d3-e315f5fa4f44'],

    //SSO API KEYS:
    localSSOApiKeys: ['8f9dc9b7-4652-4a75-8a00-859dc69d02b6','08254e92-5050-4a6f-a764-bf288b15d569','6a1ff456-19a1-47c9-9706-48b75b40a0eb'],
    devSSOApiKeys: ['8f9dc9b7-4652-4a75-8a00-859dc69d02b6','08254e92-5050-4a6f-a764-bf288b15d569','6a1ff456-19a1-47c9-9706-48b75b40a0eb'],
    qaSSOApiKeys: ['75ecc1fb-8408-4c27-940f-4b392adfdcd3','68e501b6-8dc9-4794-8110-72acaa1d41ce','1302c464-2c88-45af-9f2a-37434945980f'],
    uatSSOApiKeys: ['f5825a00-05eb-458a-9b49-2c1a7d0ec8c2','893f63ea-73ad-481e-b073-45f72202ca6a','3117f6d6-223d-4934-b05c-573a8cb7d651'],
    stgSSOApiKeys: ['34d3d70b-d268-41d9-982a-c881385347c8','f2ef5aaa-9db2-4872-a31f-72f3799e7894','9e1a369c-bbe4-4eee-aa8e-2e436e2d58c9'],
    ProdSSOApiKeys: ['d18a8d98-2770-42fb-8a8b-4fd70617c705','e3520a11-4e75-4e85-be4a-d3d5252d5fba','b4f9eeb1-ba82-44c1-a2e4-a99f911de121'],

    //Master API KEYS:
    localMasterApiKeys: ['d3df6a6d-a89a-4da8-b8a8-3567aef549e9','cbe5517e-a9f3-4d58-9dc4-d7071df989e9','39cb2e6d-1ddc-42de-afdf-e9a40618aeec'],
    devMasterApiKeys: ['d3df6a6d-a89a-4da8-b8a8-3567aef549e9','cbe5517e-a9f3-4d58-9dc4-d7071df989e9','39cb2e6d-1ddc-42de-afdf-e9a40618aeec'],
    qaMasterApiKeys: ['a9259b68-f3e7-4722-a4e7-89d6724f5f69','189cc963-5c1e-4f17-926d-04ce84900942','356cc204-9eac-4b26-9c6c-559e257143eb'],
    uatMasterApiKeys: ['f47a5e7b-791e-41a7-8f2d-9fb6e3fe2327','9b81c20c-4233-4065-a7cd-2ea7ee368199','c4907cac-cc8c-4e2d-93e7-bb1dd99883ef'],
    stgMasterApiKeys: ['68773104-e162-42f8-956f-16e407e95c95','c8708387-4ebe-4cad-8042-03dbf057a995','b695662b-51f1-4115-8cca-bd0902d1920a'],
    ProdMasterApiKeys: ['547d3692-f095-4ac2-9d30-b5aacb601d0e','c45150b9-9182-4795-a311-d87ac8cfb1b0','b5bcdfff-b3fe-4e08-8bf6-371b595e5706'],

    //Document API KEYS:
    localDocApiKeys: ['6342c466-d4f3-42ce-87d2-44c006cc203c','e4f56dd4-53ed-41c7-a2c4-459b7617c195','d575193a-8755-41ed-87fc-37f2470ae8dd'],
    devDocApiKeys: ['6342c466-d4f3-42ce-87d2-44c006cc203c','e4f56dd4-53ed-41c7-a2c4-459b7617c195','d575193a-8755-41ed-87fc-37f2470ae8dd'],
    qaDocApiKeys: ['046539ca-821a-449b-bcf8-6ceaa1355c54','af1b0b9c-b48e-4462-a4ed-bfe7f3b1a524','cd2258b4-e49c-4d48-9fd3-7ea14f78a7b7'],
    uatDocApiKeys: ['d0f361e8-efe7-4d27-9904-0293f9ce348c','d0bcffbb-927e-4f5b-a36d-d6fedff21939','88cb01f7-baf4-4baa-9f1b-b9152a82fb64'],
    stgDocApiKeys: ['cf2919e6-85a3-4c8f-bc29-f883d836400c','1c842dcc-a4b7-49e5-b110-08d49b6d9ead','ba99e757-2201-4439-b993-408c5d3cb9a4'],
    ProdDocApiKeys: ['1ea37d2c-768a-4a30-b209-604572cca795','1291f964-dc73-4927-a3dc-1982535bb311','3505af56-a56e-42b4-a54f-6cf477e4890c'],

    MainframeInteractionApiKeys: ['8e2c3b4a-5f6d-47c1-9e0a-1b2c3d4e5f60', 'd1e0f9c8-7a6b-45d2-83e4-f5a6b7c8d9e0', '2f4a6b8c-1d3e-4f50-91a2-3b4c5d6e7f80'],
};

const errorFormName = "API Config";

let dynamicClientApiUrl = "";
let dynamicSSOApiUrl = "";
let dynamicMasterApiUrl = "";
let dynamicDocApiUrl = "";

let dynamicClientApiKey = [];
let dynamicSSOApiKey = [];
let dynamicMasterApiKey = [];
let dynamicDocApiKey = [];
let dynamicScrapeApiKey = [];


// Assigning Client API URL based on the environment.
const GetApiDomainClient = async (configLibrary = null) => {
    try {
	    // Use passed config if available
        if (configLibrary?.apiClientUrl && configLibrary?.clientApiKeys && Array.isArray(configLibrary.clientApiKeys) && configLibrary.clientApiKeys.length > 0) {
            console.log("Using Client API from config.json.");
            return { 
                clientURL: configLibrary.apiClientUrl, 
                clientKey: configLibrary.clientApiKeys 
            };
        }
        console.log("Config not provided, using environment-based Client API detection");
									 
        /* console.log("Client API Host Name: " + window.location.hostname.toLowerCase()); */
        if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.localClientApiUrl.toLowerCase()) {
            return { clientURL: 'https://' + ApiPrimaryUrls.localClientApiUrl + ':7183', clientKey: ApiGuidKeys.localClientApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.devFrontEndUrl.toLowerCase()) {
            return { clientURL: 'https://' + ApiPrimaryUrls.devClientApiUrl, clientKey: ApiGuidKeys.devClientApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.qaFrontEndUrl.toLowerCase()) {
            return { clientURL: 'https://' + ApiPrimaryUrls.qaClientApiUrl, clientKey: ApiGuidKeys.qaClientApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.uatFrontEndUrl.toLowerCase()) {
            return { clientURL: 'https://' + ApiPrimaryUrls.uatClientApiUrl, clientKey: ApiGuidKeys.uatClientApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.stgFrontEndUrl.toLowerCase()) {
            return { clientURL: 'https://' + ApiPrimaryUrls.stgClientApiUrl, clientKey: ApiGuidKeys.stgClientApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.prodFrontEndUrl.toLowerCase()) {
            return { clientURL: 'https://' + ApiPrimaryUrls.ProdClientApiUrl, clientKey: ApiGuidKeys.ProdClientApiKeys };
        }
        else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.devWfFrontEndUrl.toLowerCase()) {
            return { clientURL: 'https://' + ApiPrimaryUrls.devClientApiUrl, clientKey: ApiGuidKeys.devClientApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.qaWfFrontEndUrl.toLowerCase()) {
            return { clientURL: 'https://' + ApiPrimaryUrls.qaClientApiUrl, clientKey: ApiGuidKeys.qaClientApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.uatWfFrontEndUrl.toLowerCase()) {
            return { clientURL: 'https://' + ApiPrimaryUrls.uatClientApiUrl, clientKey: ApiGuidKeys.uatClientApiKeys };
        }

        return { clientURL: 'https://' + ApiPrimaryUrls.localClientApiUrl + ':7183', clientKey: ApiGuidKeys.localClientApiKeys }; // Default 
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetApiDomainClient", {});
    }
};

// Assigning SSO API URL based on the environment.
const GetApiDomainSSO = async (configLibrary = null) => {
    try {
	    // Use passed config if available
        if (configLibrary?.apiSSOUrl && configLibrary?.ssoApiKeys && Array.isArray(configLibrary.ssoApiKeys) && configLibrary.ssoApiKeys.length > 0) {
            console.log("Using SSO API from config.json");
            return { 
                ssoURL: configLibrary.apiSSOUrl, 
                ssoKey: configLibrary.ssoApiKeys 
            };
        }
        console.log("Config not provided, using environment-based SSO API detection");
									 
        /* console.log("SSO API Host Name: " + window.location.hostname.toLowerCase()); */
        if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.localSSOApiUrl.toLowerCase()) {
            return { ssoURL: 'https://' + ApiPrimaryUrls.localSSOApiUrl + ':7108', ssoKey: ApiGuidKeys.localSSOApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.devFrontEndUrl.toLowerCase()) {
            return { ssoURL: 'https://' + ApiPrimaryUrls.devSSOApiUrl, ssoKey: ApiGuidKeys.devSSOApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.qaFrontEndUrl.toLowerCase()) {
            return { ssoURL: 'https://' + ApiPrimaryUrls.qaSSOApiUrl, ssoKey: ApiGuidKeys.qaSSOApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.uatFrontEndUrl.toLowerCase()) {
            return { ssoURL: 'https://' + ApiPrimaryUrls.uatSSOApiUrl, ssoKey: ApiGuidKeys.uatSSOApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.stgFrontEndUrl.toLowerCase()) {
            return { ssoURL: 'https://' + ApiPrimaryUrls.stgSSOApiUrl, ssoKey: ApiGuidKeys.stgSSOApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.prodFrontEndUrl.toLowerCase()) {
            return { ssoURL: 'https://' + ApiPrimaryUrls.ProdSSOApiUrl, ssoKey: ApiGuidKeys.ProdSSOApiKeys };
        }
        else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.devWfFrontEndUrl.toLowerCase()) {
            return { ssoURL: 'https://' + ApiPrimaryUrls.devSSOApiUrl, ssoKey: ApiGuidKeys.devSSOApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.qaWfFrontEndUrl.toLowerCase()) {
            return { ssoURL: 'https://' + ApiPrimaryUrls.qaSSOApiUrl, ssoKey: ApiGuidKeys.qaSSOApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.uatWfFrontEndUrl.toLowerCase()) {
            return { ssoURL: 'https://' + ApiPrimaryUrls.uatSSOApiUrl, ssoKey: ApiGuidKeys.uatSSOApiKeys };
        }

        return { ssoURL: 'https://' + ApiPrimaryUrls.localSSOApiUrl + ':7108', ssoKey: ApiGuidKeys.localSSOApiKeys }; // Default 
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetApiDomainSSO", {});
    }
};

// Assigning Master API URL based on the environment.
const GetApiDomainMaster = async (configLibrary = null) => {
    try {
	    // Use passed config if available
        if (configLibrary?.apiMasterUrl && configLibrary?.masterApiKeys && Array.isArray(configLibrary.masterApiKeys) && configLibrary.masterApiKeys.length > 0) {
            console.log("Using Master API from config.json");
            return { 
                masterURL: configLibrary.apiMasterUrl, 
                masterKey: configLibrary.masterApiKeys 
            };
        }
        console.log("Config not provided, using environment-based Master API detection");
									 
        /* console.log("Master API Host Name: " + window.location.hostname.toLowerCase()); */
        if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.localMasterApiUrl.toLowerCase()) {
            return { masterURL: 'https://' + ApiPrimaryUrls.localMasterApiUrl + ':7238', masterKey: ApiGuidKeys.localMasterApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.devFrontEndUrl.toLowerCase()) {
            return { masterURL: 'https://' + ApiPrimaryUrls.devMasterApiUrl, masterKey: ApiGuidKeys.devMasterApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.qaFrontEndUrl.toLowerCase()) {
            return { masterURL: 'https://' + ApiPrimaryUrls.qaMasterApiUrl, masterKey: ApiGuidKeys.qaMasterApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.uatFrontEndUrl.toLowerCase()) {
            return { masterURL: 'https://' + ApiPrimaryUrls.uatMasterApiUrl, masterKey: ApiGuidKeys.uatMasterApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.stgFrontEndUrl.toLowerCase()) {
            return { masterURL: 'https://' + ApiPrimaryUrls.stgMasterApiUrl, masterKey: ApiGuidKeys.stgMasterApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.prodFrontEndUrl.toLowerCase()) {
            return { masterURL: 'https://' + ApiPrimaryUrls.ProdMasterApiUrl, masterKey: ApiGuidKeys.ProdMasterApiKeys };
        }
        else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.devWfFrontEndUrl.toLowerCase()) {
            return { masterURL: 'https://' + ApiPrimaryUrls.devMasterApiUrl, masterKey: ApiGuidKeys.devMasterApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.qaWfFrontEndUrl.toLowerCase()) {
            return { masterURL: 'https://' + ApiPrimaryUrls.qaMasterApiUrl, masterKey: ApiGuidKeys.qaMasterApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.uatWfFrontEndUrl.toLowerCase()) {
            return { masterURL: 'https://' + ApiPrimaryUrls.uatMasterApiUrl, masterKey: ApiGuidKeys.uatMasterApiKeys };
        }

        return { masterURL: 'https://' + ApiPrimaryUrls.localMasterApiUrl + ':7238', masterKey: ApiGuidKeys.localMasterApiKeys }; // Default 
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetApiDomainMaster", {});
    }
};

// Assigning Doc API URL based on the environment.
const GetApiDomainDoc = async (configLibrary = null) => {
    try {
	    // Use passed config if available
        if (configLibrary?.apiDocUrl && configLibrary?.docApiKeys && Array.isArray(configLibrary.docApiKeys) && configLibrary.docApiKeys.length > 0) {
            console.log("Using Doc API from config.json.");
            return { 
                docURL: configLibrary.apiDocUrl, 
                docKey: configLibrary.docApiKeys 
            };
        }
        console.log("Config not provided, using environment-based Doc API detection");
									 
        /* console.log("Document API Host Name: " + window.location.hostname.toLowerCase()); */
        if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.localDocApiUrl.toLowerCase()) {
            return { docURL: 'https://' + ApiPrimaryUrls.localDocApiUrl + ':7203', docKey: ApiGuidKeys.localDocApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.devFrontEndUrl.toLowerCase()) {
            return { docURL: 'https://' + ApiPrimaryUrls.devDocApiUrl, docKey: ApiGuidKeys.devDocApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.qaFrontEndUrl.toLowerCase()) {
            return { docURL: 'https://' + ApiPrimaryUrls.qaDocApiUrl, docKey: ApiGuidKeys.qaDocApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.uatFrontEndUrl.toLowerCase()) {
            return { docURL: 'https://' + ApiPrimaryUrls.uatDocApiUrl, docKey: ApiGuidKeys.uatDocApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.stgFrontEndUrl.toLowerCase()) {
            return { docURL: 'https://' + ApiPrimaryUrls.stgDocApiUrl, docKey: ApiGuidKeys.stgDocApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.prodFrontEndUrl.toLowerCase()) {
            return { docURL: 'https://' + ApiPrimaryUrls.ProdDocApiUrl, docKey: ApiGuidKeys.ProdDocApiKeys };
        }
        else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.devWfFrontEndUrl.toLowerCase()) {
            return { docURL: 'https://' + ApiPrimaryUrls.devDocApiUrl, docKey: ApiGuidKeys.devDocApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.qaWfFrontEndUrl.toLowerCase()) {
            return { docURL: 'https://' + ApiPrimaryUrls.qaDocApiUrl, docKey: ApiGuidKeys.qaDocApiKeys };
        } else if (window.location.hostname.toLowerCase() === ApiPrimaryUrls.uatWfFrontEndUrl.toLowerCase()) {
            return { docURL: 'https://' + ApiPrimaryUrls.uatDocApiUrl, docKey: ApiGuidKeys.uatDocApiKeys };
        }

        return { docURL: 'https://' + ApiPrimaryUrls.localDocApiUrl + ':7203', docKey: ApiGuidKeys.localDocApiKeys }; // Default 
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetApiDomainDoc", {});
    }
};

const isEmptyArray = (arrayToCheck = []) => {
    if (arrayToCheck.length === 0) {
        return true;
    }
    return false;
};

const GetClientAPIurl = async () => {
    try {
        if ((dynamicClientApiUrl === '') || (isEmptyArray(dynamicClientApiKey))) {
            const { clientURL, clientKey } = await GetApiDomainClient(configLibrary);
            dynamicClientApiUrl = clientURL;
            dynamicClientApiKey = clientKey;
        }
        return dynamicClientApiUrl;
    }
    catch (error) {
        await LoggerUtility.ManageErrorLogging(error, errorFormName, "GetClientAPIurl");
    }
};

const GetSSOAPIurl = async () => {
    try {
        if ((dynamicSSOApiUrl === '') || (isEmptyArray(dynamicSSOApiKey === ''))) {
            const { ssoURL, ssoKey } = await GetApiDomainSSO(configLibrary);
            dynamicSSOApiUrl = ssoURL;
            dynamicSSOApiKey = ssoKey;
        }
        return dynamicSSOApiUrl;
    }
    catch (error) {
        await LoggerUtility.ManageErrorLogging(error, errorFormName, "GetSSOAPIurl");
    }
};

const GetMasterAPIurl = async () => {
    try {
        if ((dynamicMasterApiUrl === '') || (isEmptyArray(dynamicMasterApiKey === ''))) {
            const { masterURL, masterKey } = await GetApiDomainMaster(configLibrary);
            dynamicMasterApiUrl = masterURL;
            dynamicMasterApiKey = masterKey;
        }
        return dynamicMasterApiUrl;
    }
    catch (error) {
        await LoggerUtility.ManageErrorLogging(error, errorFormName, "GetMasterAPIurl");
    }
};

const GetDocAPIurl = async () => {
    try {
        if ((dynamicDocApiUrl === '') || (isEmptyArray(dynamicDocApiKey === ''))) {
            const { docURL, docKey } = await GetApiDomainDoc(configLibrary);
            dynamicDocApiUrl = docURL;
            dynamicDocApiKey = docKey;
        }
        return dynamicDocApiUrl;
    }
    catch (error) {
        await LoggerUtility.ManageErrorLogging(error, errorFormName, "GetDocAPIurl");
    }
};

const ClientApiUrl = await GetClientAPIurl().then(url => url + '/api/');
const ClientRequestorKey = EnumUtility.ApiRequestorKey.ClientAPI.ID;

const SsoApiUrl = await GetSSOAPIurl().then(url => url + '/api/');
const SsoRequestorKey = EnumUtility.ApiRequestorKey.SsoAPI.ID;

const MasterApiUrl = await GetMasterAPIurl().then(url => url + '/api/');
const MasterRequestorKey = EnumUtility.ApiRequestorKey.MasterAPI.ID;

const DocumentApiUrl = await GetDocAPIurl().then(url => url + '/api/');
const DocumentRequestorKey = EnumUtility.ApiRequestorKey.DocumentAPI.ID;

export const ApiEndpoints = {

    PostBatchInsertUpdateApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'Batch/BatchInsertUpdate', ApiKey: ClientRequestorKey }) ,

    PostNewDocSaveApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'NewDocSave/InsertUpdate', ApiKey: ClientRequestorKey }) ,

    PostDocTransferLogG4ApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'DocTransferLog/Insert', ApiKey: ClientRequestorKey }) ,

    PostManageKeywordSaveApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'ManageKeySave/InsertUpdate', ApiKey: ClientRequestorKey }) ,

    PostBatchDocumentApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'BatchDocument/InsertUpdate', ApiKey: ClientRequestorKey }) ,

    PostLogManageApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'LogManage/StoreReactLog', ApiKey: ClientRequestorKey }) ,

    UserLockedBatchApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'UserSessionData/GetLockedBatchID', ApiKey: ClientRequestorKey }) ,
    BatchLockStatusApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'BatchLockStatus/GetStatus', ApiKey: ClientRequestorKey }) ,
    UpdateBatchLockStatusApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'BatchLockStatus/Update', ApiKey: ClientRequestorKey }) ,
    BatchListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'Batch/GetBatchList', ApiKey: ClientRequestorKey }) ,
    BatchInfoApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'Batch/GetBatchInfoList/', ApiKey: ClientRequestorKey }) ,
    DocTypeListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'DocType/GetDocTypeList', ApiKey: ClientRequestorKey }) ,
    DocSourceListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'DocumentSource/GetDocumentSourceList', ApiKey: ClientRequestorKey }) ,
    DocGroupListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'DocGroup/GetDocGroupList', ApiKey: ClientRequestorKey }),
    MapCodeWorkflowApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'MapCodeWorkflow/GetMapCodeWorkflow', ApiKey: ClientRequestorKey }) ,
    IndexByListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'IndexUser/GetIndexList', ApiKey: ClientRequestorKey }) ,
    BatchDocumentsApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'BatchDocument/GetBatchDocumentList', ApiKey: ClientRequestorKey }) ,
    BatchDocumentByIdApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'BatchDocument/GetBatchDocumentByID', ApiKey: ClientRequestorKey }) ,
    BatchDocumentLockStatusSelectUrl:  async () => ({ ApiUrl: (await ClientApiUrl) + 'BatchDocument/GetStatus', ApiKey: ClientRequestorKey }) ,
    UpdateBatchDocumentLockStatusUrl:  async () => ({ ApiUrl: (await ClientApiUrl) + 'BatchDocument/Update', ApiKey: ClientRequestorKey }) ,
    CaseDetailsApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'Case/GetCaseList', ApiKey: ClientRequestorKey }) ,
    CaseDetailsWYAPIApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'Case/GetCaseList_WY_API', ApiKey: ClientRequestorKey }),
    CaseDetailsVAAPIApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'Case/GetCaseList_VA_API', ApiKey: ClientRequestorKey }) ,
    CaseDetailsKSAPIApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'Case/GetCaseList_KS_API', ApiKey: ClientRequestorKey }) ,
    CaseDocumentsApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'CaseDocument/GetCaseDocumentList', ApiKey: ClientRequestorKey }) ,
    DocumentsByCaseWorkflowIDApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'CaseDocument/GetDocumentListByCaseWorkflow', ApiKey: ClientRequestorKey }) ,
    CaseByBatchDocumentApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'CaseDocument/GetCasesByBatchDocumentID', ApiKey: ClientRequestorKey }) ,
    CaseInsertUpdateApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'CaseInsertUpdate/CaseInsertUpdate', ApiKey: ClientRequestorKey }) ,
    DocumentSearchApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'Document/GetDocumentList', ApiKey: ClientRequestorKey }) ,
    ClientDocumentMetadataApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'document/metadata', ApiKey: ClientRequestorKey }) ,
    NarrativeGetApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'Narrative/GetNarrative', ApiKey: ClientRequestorKey }) ,
    NarrativeForKeywordsGetApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'NarrativeManageKey/GetNarrative', ApiKey: ClientRequestorKey }),
    NarrativeBuilderApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'Narrative/BuildNarrative', ApiKey: ClientRequestorKey }),
    AddCaseNarrativeKSAPIApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'Narrative/AddCaseNarrative_KS_API', ApiKey: ClientRequestorKey }),
    DeleteAlertKSAPIApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'Alert/DeleteAlert_KS_API', ApiKey: ClientRequestorKey }),
    JScapeExportDocumentApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'JScape/ExportDocuments', ApiKey: ClientRequestorKey, Method: 'POST' }),
    ExportDocLogApiUrl: async() => ({ApiUrl: (await ClientApiUrl) + 'DocExportLog/InsertDocExportLog', ApiKey: ClientRequestorKey, Method: 'POST'}),

    /*
    ==========================================
    WORKFLOW API - BEGIN
    =========================================== 
    */

    WorkflowTypesApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'WorkflowType/GetWorkflowTypeList', ApiKey: ClientRequestorKey }),
    NextTabEnableWorkflowsApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'WorkflowType/GetWorkTabEnableWorkflowsList', ApiKey: ClientRequestorKey }),
    GetActiveWorkflowListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'ActiveWorkflowSelect/GetActiveWorkflowSelectList', ApiKey: ClientRequestorKey }),
    GetActiveQueueListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'ActiveQueue/GetActiveQueueList', ApiKey: ClientRequestorKey }),
    ActionTypeListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'ActionType/GetActionTypeList', ApiKey: ClientRequestorKey }),
    NextActionTypeListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'NextActionType/GetNextActionTypeList', ApiKey: ClientRequestorKey }),
    NextActionTypeListReferActionApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'NextActionType/GetNextActionTypeListReferAction', ApiKey: ClientRequestorKey }),
    IccTypeListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'WorkflowICCType/GetWorkflowICCTypeList', ApiKey: ClientRequestorKey }),
    WorkflowGetNarrativeApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'WorkflowNarrative/GetNarrative', ApiKey: ClientRequestorKey }),
    WorkflowSaveApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'WorkflowSave/InsertUpdate', ApiKey: ClientRequestorKey }),
    WalkInSaveApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'WorkflowSave/WalkINInsertUpdate', ApiKey: ClientRequestorKey }),
    WorkflowSaveExistingApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'WorkflowSaveExistingCaseWorkflow/WorkflowTakeAction', ApiKey: ClientRequestorKey }),
    TakeActionApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'CaseWorkflow/TakeAction', ApiKey: ClientRequestorKey }),//TODO will be used for lock check


    ActiveWorkflowFinancialWorkListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'ActiveWorkflowFinancial/GetActiveWorkflowFinancialList', ApiKey: ClientRequestorKey }),
    ActiveWorkflowNoCaseFinancialWorkListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'ActiveWorkflowFinancial/GetActiveWorkflowNoCaseFinancialList', ApiKey: ClientRequestorKey }),

    LockUnlockCaseWorkflowByCaseWorkflowIDApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'CaseWorkflow/CaseWorkflowLockUnlock', ApiKey: ClientRequestorKey }),
    UnlockCaseWorkflowsByUseLoginIDApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'CaseWorkflow/UnlockAllCaseWorkflowForUser', ApiKey: ClientRequestorKey }),

    WorkflowActivityListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'WorkflowActivity/GetWorkflowActivityList', ApiKey: ClientRequestorKey }),
    ActionDetailsApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'WorkflowActivity/GetActionDetails', ApiKey: ClientRequestorKey }),

    NoCaseWorkflowActivityListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'WorkflowActivity/GetNoCaseWorkflowActivityList', ApiKey: ClientRequestorKey }),
    CustServiceContactListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'CustServiceContacts/GetCustServiceContactList', ApiKey: ClientRequestorKey }),
    //new added for work flow status dropdown options
    WorkflowStatusOptionsApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'DropdownType/GetAllDropdownTypes', ApiKey: ClientRequestorKey }),
    CompletedActionsSearchApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'CompletedActions/Search', ApiKey: ClientRequestorKey }),
    StartQAWorkflowsApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'WorkflowActivity/WorkflowActivityQAStatusSelectUpdate', ApiKey: ClientRequestorKey }),
    CompletedSitesApiUrl: async () => ({ ApiUrl: (await MasterApiUrl) + 'CompletedSite/GetCompletedSites', ApiKey: MasterRequestorKey }),
    CompletedUsersApiUrl: async () => ({ ApiUrl: (await MasterApiUrl) + 'CompletedUser/GetCompletedUsers', ApiKey: MasterRequestorKey }),

    EventsGridDataNoCaseApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'CustServiceContacts/GetEventsGridDataNoCase', ApiKey: ClientRequestorKey }),
    ActiveWorkflowInitialInfoListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'ActiveWorkflowInitialInfo/GetActiveWorkflowInitialInfoList', ApiKey: ClientRequestorKey }),
    ActiveWorkflowSelectListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'ActiveWorkflowSelect/GetActiveWorkflowSelectList', ApiKey: ClientRequestorKey }),
    ActiveQueueListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'ActiveQueue/GetActiveQueueList', ApiKey: ClientRequestorKey }),
    ActiveWorkflowWorkListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'ActiveWorkflowWork/GetActiveWorkflowWorkList', ApiKey: ClientRequestorKey }),
    AutoEndWorkflowsListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'AutoEndWorkflows/GetAutoEndWorkflowsList', ApiKey: ClientRequestorKey }),
    ActionOptionsListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'ActionOptions/GetActionOptionsList', ApiKey: ClientRequestorKey }),
    ActiveWorkflowWalkInListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'ActiveWorkflowWalkIn/GetActiveWorkflowWalkInList', ApiKey: ClientRequestorKey }),
    ActiveWorkflowLegalListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'ActiveWorkflowLegal/GetActiveWorkflowLegalList', ApiKey: ClientRequestorKey }),

    ChannelRoleCategoryOptionsApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'WalkInDropdowns/GetChannelRoleCategoryOptions', ApiKey: ClientRequestorKey }),
    
   ResultListTypeDataApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'WalkInDropdowns/GetResultListTypeData', ApiKey: ClientRequestorKey }),

   ResultListMapDataApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'WalkInDropdowns/GetResultListMapData', ApiKey: ClientRequestorKey }),

    WorkflowDocumentsApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'CaseDocument/GetWorkflowDocuments', ApiKey: ClientRequestorKey }) ,


    // Next Work Item
    GetNextTaskApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'WorkflowGetNextTask/GetWorkflowNextTask', ApiKey: ClientRequestorKey }),
    AddToListApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'CaseWorkflow/AddToList', ApiKey: ClientRequestorKey }),
    /*
    ==========================================
    WORKFLOW API - END
    ===========================================
    */

    AppBarPermissionsApiUrl: async () => ({ ApiUrl: (await SsoApiUrl) + 'security/GetAppBarPermissions', ApiKey: SsoRequestorKey }) ,
    SecurityControlsApiUrl: async () => ({ ApiUrl: (await SsoApiUrl) + 'security/GetControlSecurity', ApiKey: SsoRequestorKey }) ,
    ControlAccessApiUrl: async () => ({ ApiUrl: (await SsoApiUrl) + 'controlaccess', ApiKey: SsoRequestorKey }) ,
    OrgsApiUrl: async () => ({ ApiUrl: (await SsoApiUrl) + 'Orgs/GetOrgsByUserID', ApiKey: SsoRequestorKey }) ,
    ChildOrgsApiUrl: async () => ({ ApiUrl: (await SsoApiUrl) + 'Orgs/GetChildOrgsByUserID', ApiKey: SsoRequestorKey }) ,
    UserByEmailApiUrl: async () => ({ ApiUrl: (await SsoApiUrl) + 'User/email', ApiKey: SsoRequestorKey }) ,

    UserLoginApiUrl: async () => ({ ApiUrl: (await MasterApiUrl) + 'UserLoginInfo/GetUserLoginInfo', ApiKey: MasterRequestorKey }) ,
    SettingsDetailValuesApiUrl: async () => ({ ApiUrl: (await MasterApiUrl) + 'SettingsDetail/GetSettingsDetails', ApiKey: MasterRequestorKey }),
    IntegrationIDApiUrl: async () => ({ ApiUrl: (await MasterApiUrl) + 'Integration/GetIntegration', ApiKey: MasterRequestorKey }) ,
    IntegrationInfoApiUrl: async () => ({ ApiUrl: (await MasterApiUrl) + 'Integration/GetIntegrationInfo', ApiKey: MasterRequestorKey }) ,
    MessageContentApiUrl: async () => ({ ApiUrl: (await MasterApiUrl) + 'MessageContent/GetMessageContentInfo', ApiKey: MasterRequestorKey }) ,
    HolidayListApiUrl: async () => ({ ApiUrl: (await MasterApiUrl) + 'Holidays/GetHolidaysBySite', ApiKey: MasterRequestorKey }) ,
    NoteTemplateApiUrl: async () => ({ ApiUrl: (await MasterApiUrl) + 'NoteTemplate/GetNoteTemplate', ApiKey: MasterRequestorKey }) ,
    DataMapApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'DataMap/GetDataMap', ApiKey: ClientRequestorKey }),
    ActiveWorkflowActionsApiUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'WorkflowSave/GetActiveWorkflowActions', ApiKey: ClientRequestorKey }),
    ActiveCaseWorkflowListWithCaseUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'ActiveCaseWorkflowList/GetActiveWorkflowWithCase', ApiKey: ClientRequestorKey }),
    ActiveCaseWorkflowListNoCaseUrl: async () => ({ ApiUrl: (await ClientApiUrl) + 'ActiveCaseWorkflowList/GetActiveWorkflowNoCase', ApiKey: ClientRequestorKey }),
    SystemInformationApiUrl: async () => ({ ApiUrl: (await MasterApiUrl) + 'SystemInformation/GetSystemInformation', ApiKey: MasterRequestorKey }) ,
    

    DocumentUncApiUrl: async () => ({ ApiUrl: (await DocumentApiUrl) + 'document', ApiKey: DocumentRequestorKey }) ,
    DocumentUploadApiUrl: async () => ({ ApiUrl: (await DocumentApiUrl) + 'document/upload', ApiKey: DocumentRequestorKey }) ,
    DocumentExistsApiUrl: async () => ({ ApiUrl: (await DocumentApiUrl) + 'document/CheckFileExists', ApiKey: DocumentRequestorKey }) ,
    DocumentDeleteApiUrl: async () => ({ ApiUrl: (await DocumentApiUrl) + 'document/deleteDocument', ApiKey: DocumentRequestorKey }) ,
    ContactNextIDApiUrl: async () => ({ApiUrl: (await ClientApiUrl) + 'Contact/GetNextContact', ApiKey: ClientRequestorKey}),


    // SignalR Scrape API Related URLs
    SignalRScrapeHubConnectionApiUrl: async () => ({ ApiUrl: await 'scrapeHub?legacyId=', ApiKey: ClientRequestorKey }),
    SignalRScrapeRequestApiUrl: async () => ({ ApiUrl: await 'scrape/request', ApiKey: ClientRequestorKey }),
    SignalRScrapeResponseApiUrl: async () => ({ ApiUrl: await 'scrape/response/', ApiKey: ClientRequestorKey }),
    SignalRScrapeCompleteApiUrl: async () => ({ ApiUrl: await 'scrape/complete/', ApiKey: ClientRequestorKey }),
    SignalRScrapeTimeoutApiUrl: async () => ({ ApiUrl: await 'scrape/timeout/', ApiKey: ClientRequestorKey }),

};

let indexClientApi = 0;
let indexSsoApi = 0;
let indexMasterApi = 0;
let indexDocApi = 0;


const GetClientApiKey = () => {
    if (isEmptyArray(dynamicClientApiKey)) {
        return ApiGuidKeys.localClientApiKeys[0];
    }
    const guidKey = dynamicClientApiKey[indexClientApi];
    indexClientApi = (indexClientApi + 1) % dynamicClientApiKey.length;
    return guidKey;
};


const GetSsoApiKey = () => {
    if (isEmptyArray(dynamicSSOApiKey)) {
        return ApiGuidKeys.localSSOApiKeys[0];
    }
    const guidKey = dynamicSSOApiKey[indexSsoApi];
    indexSsoApi = (indexSsoApi + 1) % dynamicSSOApiKey.length;
    return guidKey;
};


const GetMasterApiKey = () => {
    if (isEmptyArray(dynamicMasterApiKey)) {
        return ApiGuidKeys.localMasterApiKeys[0];
    }
    const guidKey = dynamicMasterApiKey[indexMasterApi];
    indexMasterApi = (indexMasterApi + 1) % dynamicMasterApiKey.length;
    return guidKey;
};


const GetDocApiKey = () => {
    if (isEmptyArray(dynamicDocApiKey)) {
        return ApiGuidKeys.localDocApiKeys[0];
    }
    const guidKey = dynamicDocApiKey[indexDocApi];
    indexDocApi = (indexDocApi + 1) % dynamicDocApiKey.length;
    return guidKey;
};


const GetMainframeScrapeApiKey = () => {
    return ApiGuidKeys.MainframeInteractionApiKeys[0];
    /* if (isEmptyArray(dynamicDocApiKey)) {
        return ApiGuidKeys.localDocApiKeys[0];
    }
    const guidKey = dynamicDocApiKey[indexDocApi];
    indexDocApi = (indexDocApi + 1) % dynamicDocApiKey.length;
    return guidKey; */
};

const ApiKeyManager = {
    GetClientApiKey,
    GetSsoApiKey,
    GetMasterApiKey,
    GetDocApiKey,
    GetMainframeScrapeApiKey,
};

export default ApiKeyManager;
